export default __webpack_public_path__ + "static/media/questionThumbnail.b9035768.svg";